var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnowmobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1631)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2215 23.302C18.5785 23.302 18.8658 23.0148 18.8658 22.6577C18.8658 22.3007 18.5785 22.0134 18.2215 22.0134C17.8644 22.0134 17.5772 22.3007 17.5772 22.6577C17.5772 23.0148 17.8644 23.302 18.2215 23.302Z",
    fill: "#132439"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0134 22.6577C21.0134 22.3007 20.7262 22.0134 20.3691 22.0134C20.0121 22.0134 19.7248 22.3007 19.7248 22.6577C19.7248 23.0148 20.0121 23.302 20.3691 23.302C20.7262 23.302 21.0134 23.0148 21.0134 22.6577Z",
    fill: "#132439"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5168 23.302C22.8738 23.302 23.1611 23.0148 23.1611 22.6577C23.1611 22.3007 22.8738 22.0134 22.5168 22.0134C22.1597 22.0134 21.8725 22.3007 21.8725 22.6577C21.8725 23.0148 22.1597 23.302 22.5168 23.302Z",
    fill: "#132439"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1611 22.6577C23.1611 23.0148 22.8738 23.302 22.5168 23.302C22.1597 23.302 21.8725 23.0148 21.8725 22.6577C21.8725 22.3007 22.1597 22.0134 22.5168 22.0134C22.8738 22.0134 23.1611 22.3007 23.1611 22.6577ZM20.3691 22.0134C20.7262 22.0134 21.0134 22.3007 21.0134 22.6577C21.0134 23.0148 20.7262 23.302 20.3691 23.302C20.0121 23.302 19.7248 23.0148 19.7248 22.6577C19.7248 22.3007 20.0121 22.0134 20.3691 22.0134ZM18.8658 22.6577C18.8658 23.0148 18.5785 23.302 18.2215 23.302C17.8644 23.302 17.5772 23.0148 17.5772 22.6577C17.5772 22.3007 17.8644 22.0134 18.2215 22.0134C18.5785 22.0134 18.8658 22.3007 18.8658 22.6577Z",
    fill: "#132439"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5168 23.302C22.8738 23.302 23.1611 23.0148 23.1611 22.6577C23.1611 22.3007 22.8738 22.0134 22.5168 22.0134C22.1597 22.0134 21.8725 22.3007 21.8725 22.6577C21.8725 23.0148 22.1597 23.302 22.5168 23.302ZM21.0134 22.6577C21.0134 22.3007 20.7262 22.0134 20.3691 22.0134C20.0121 22.0134 19.7248 22.3007 19.7248 22.6577C19.7248 23.0148 20.0121 23.302 20.3691 23.302C20.7262 23.302 21.0134 23.0148 21.0134 22.6577ZM18.2215 23.302C18.5785 23.302 18.8658 23.0148 18.8658 22.6577C18.8658 22.3007 18.5785 22.0134 18.2215 22.0134C17.8644 22.0134 17.5772 22.3007 17.5772 22.6577C17.5772 23.0148 17.8644 23.302 18.2215 23.302Z",
    fill: "#132439"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0067 19.9463C16.3423 19.9463 15 21.4577 15 22.6577C15 24.3195 16.345 25.6644 18.0067 25.6644H22.7315C24.3933 25.6644 25.7383 24.3195 25.7383 22.6577C25.7383 21.4497 24.3718 19.9463 22.7181 19.9463H18.0067ZM24.0201 22.6577C24.0201 21.9463 23.443 21.3691 22.7315 21.3691H18.0067C17.2953 21.3691 16.7181 21.9463 16.7181 22.6577C16.7181 23.3691 17.2953 23.9463 18.0067 23.9463H22.7315C23.443 23.9463 24.0201 23.3691 24.0201 22.6577Z",
    fill: "#132439"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3691 21.6913C32.8443 21.6913 33.2282 21.3074 33.2282 20.8322C33.2282 20.3571 32.8443 19.9732 32.3691 19.9732L31.0268 18.255V16.894C31.0268 16.4376 30.847 16 30.5248 15.6779L27.1074 12.2604L25.8913 13.4765L29.3087 16.894V17.396H18.6742C18.3158 17.396 17.9722 17.5393 17.7201 17.7941L15.9519 19.5809C15.7033 19.8322 15.5638 20.1715 15.5638 20.525V21.3557H24.1544L25.0134 21.6913H32.3691Z",
    fill: "#132439"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.349 12.8591C27.349 13.3335 26.9644 13.7181 26.4899 13.7181C26.0155 13.7181 25.6309 13.3335 25.6309 12.8591C25.6309 12.3846 26.0155 12 26.4899 12C26.9644 12 27.349 12.3846 27.349 12.8591Z",
    fill: "#132439"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4161 21.2617H31.1342V23.9463H29.4161V21.2617Z",
    fill: "#132439"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7987 23.9463C33.2731 23.9463 33.6577 24.3309 33.6577 24.8054C33.6577 25.2798 33.2731 25.6644 32.7987 25.6644H27.4027C26.9282 25.6644 26.5436 25.2798 26.5436 24.8054C26.5436 24.3309 26.9282 23.9463 27.4027 23.9463H32.7987Z",
    fill: "#132439"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6902 23.302C34.1011 23.0648 34.6265 23.2056 34.8637 23.6165C35.1009 24.0273 34.9602 24.5527 34.5493 24.7899L33.2473 25.5416C32.8364 25.7789 32.3111 25.6381 32.0738 25.2272C31.8366 24.8163 31.9774 24.2909 32.3883 24.0537L33.6902 23.302Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1631",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1631"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowmobile);
export default __webpack_public_path__ + "static/media/snowmobile.652bc41a3418c86cc043a9e3f6d176df.svg";
export { ForwardRef as ReactComponent };